import {Inject, Injectable} from '@angular/core';
import {GeneralService} from "../../general.service";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class StandService extends GeneralService {
  constructor(
    public http: HttpClient,
    @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    super(http, httpBaseSettings);
    this.setModelPath('/airline/airportStand');
  }

}
